






















































































































































































// libs
import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';

// helpers
import ApiHelper from 'api-helper';
import Toast from '@common/helpers/toast';

// constants
import { USER_TREATMENT_STATE, USER_TREATMENT_STATE_CAN_ADD_KARTE } from '@/common/constants/auth';
import {formatDateJp, formatDateTimeJp} from '@common/app.config';
import {
  getPatientFullName,
  getPatientKanaName,
  getPatientBirthdayDisplay,
  getBMIDisplay,
} from '@/common/helpers/patient-info';

// components
import PageLoader from '@components/common/PageLoader.vue';
import BasicModal from '@components/common/BasicModal.vue';
import PrescriptionPopup from '@/components/v2/patient/message/partials/PrescriptionPopup.vue';

// interfaces
import { Patient } from '@/models/patient';
import { UserTreatment } from '@/models/user-treatment';
import PlanItem from '@/components/v2/patient/message/PlanItem.vue';

@Component({
  components: {
    PageLoader,
    BasicModal,
    PrescriptionPopup,
    PlanItem,
  },
})

export default class KarteInfoChannel extends Vue {

  get queryParams() {
    return {
      ...this.filterParams,
      ...this.paginate,
    };
  }

  // ***************** getter ***************** //
  private get isEnableConfirmingOrder() {
    return this.activeTreatment.state === USER_TREATMENT_STATE.DOCTOR_PRESCRIPTION_CHECK;
  }

  private get isDisableCreateFeedback() {
    return !USER_TREATMENT_STATE_CAN_ADD_KARTE.includes(this.activeTreatment.state);
  }

  private get confirmOrderFormRef() {
    return this.$refs.confirmOrderForm as any;
  }

  private get prescriptionPopupRef() {
    return this.$refs.prescriptionPopup as any;
  }

  private get treatmentName() {
    return this.activeTreatment.menu?.name;
  }

  private get lastFeedback() {
    return this.listFeedback.length > 0 ? this.listFeedback[this.listFeedback.length - 1] : null;
  }

  get patientFullName() {
    return getPatientFullName(this.currentPatient);
  }

  get patientKanaName() {
    return getPatientKanaName(this.currentPatient);
  }

  get patientBirthdayDisplay() {
    return getPatientBirthdayDisplay(this.currentPatient);
  }

  get bmiDisplay() {
    return getBMIDisplay(this.reservationAnswers, this.treatmentName);
  }

  get reservationAnswers() {
    return this.orderConfirm?.userTreatment?.reservations?.[0]?.answers || [];
  }

  @State((state) => state.patient_detail.data) patient!: Patient;
  @State((state) => state.treatment_detail.data) activeTreatment: UserTreatment;
  @State((state) => state.patient_detail.data) currentPatient!: Patient;

  paginate = {
    page: 1,
    per_page: 20,
    last_page: 1,
  };

  filterParams = {
    with: 'plans.medicines',
    select_field: 'id,name,status,is_default',
    clinic_id: null,
    has_plans: 1,
    clinic_ids: [] as number[],
    plans: '',
  };

  private selectedPlansFromPopup: any[] = [];

  private beingGetOrderConfirm: boolean = false;
  private isConfirming: boolean = false;
  private isLoading: boolean = false;
  private listPlanByMenuKarte: any[] = [];

  private listFeedback: any[] = [];
  private feedbackForm: any = {};
  private orderConfirm: any = {};

  private formatDateJp = formatDateJp;
  private formatDateTimeJp = formatDateTimeJp;

  async created() {
    this.$store.commit('treatment_detail/setLoadingChild', true);
    await this.getListFeedback();
    this.$store.commit('treatment_detail/setLoadingChild', false);
  }

  getQueryParams(disablePagination = false) {
    const params = {
      ...this.filterParams,
      ...(disablePagination ? {} : this.paginate),
    };
    return params;
  }

  getAllOptions(data) {
    const options = Array.isArray(data?.question?.options)
      ? data.question.options
      : [];

    const answers = Array.isArray(data?.answer)
      ? data.answer
      : [];

    const allOptions = options.map((opt) => opt.value);
    const selectedValues = answers.map((ans) => ans.value);

    return allOptions.filter((opt) => !selectedValues.includes(opt?.trim?.()));
  }

  hasOtherSelectableOptions(data: any): boolean {
    const isSelectable = ['checkbox', 'radio'].includes(data.question?.type);
    const otherOptions = this.getAllOptions(data);
    return isSelectable && otherOptions.length > 0;
  }

  private async getListFeedback() {
      const self = this;
      const payload = { user_treatment_id: this.activeTreatment.id, with: 'userTreatment.reservations.answers,plans.medicines,doctor' };
      await ApiHelper.getApi('PatientV2Api').getKarteList(this.patient.id, payload)
        .then(function(res) {
          self.listFeedback = res.data;
        })
        .catch((error: any) => {
          Toast.error(error.response.data.message);
        });
    }

  private showConfirmOrder() {
    if (!this.patient.id) {
      return;
    }

    const self = this;
    this.beingGetOrderConfirm = true;

    const params = {
      user_treatment_id: this.activeTreatment.id,
    };
    ApiHelper.getApi('PatientV2Api').getPatientOrderAccepted(this.patient.id, params)
      .then(function(res) {
        const feedback = self.listFeedback.find(
          (item: any) => item.id === res.data.doctor_feedback_id,
        );

        const plans = feedback?.plans ?? [];
        const recommendedPlan = plans.some((item: any) => item.pivot?.recommended && item.id === res.data.plan.id);

        self.orderConfirm = {
          ...res.data,
          memo: self.lastFeedback?.content ?? res.data.memo,
          plan: {
            ...res.data.plan,
            recommended: recommendedPlan,
          },
        };

        self.$modal.show('confirmOrderForm');
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(function() {
        self.beingGetOrderConfirm = false;
      });
  }

  private getListPlansByMenu(plansMenu: string = '') {
    this.isLoading = true;

    const activeMenuId = this.activeTreatment.menu?.id;

    if (this.currentPatient && this.currentPatient.clinics.length > 0) {
      this.filterParams.clinic_ids = [this.patient.clinics[0].id];
    }

    this.filterParams.plans = plansMenu;

    ApiHelper.getApi('MedicalMenuV2Api')
      .fetchPlanListV2(this.getQueryParams(true))
      .then((res) => {
        const fetchedPlans = JSON.parse(JSON.stringify(res.data));

        fetchedPlans.sort((a, b) => {
          if (a.id === activeMenuId) { return -1; }
          if (b.id === activeMenuId) { return 1; }
          return 0;
        });

        // No-75 Displays a list of non-clinic services
        // const activeMenu = fetchedPlans.find((menu) => menu.id === activeMenuId);
        // if (activeMenu) {
        //   const existingPlans = activeMenu.plans || [];

        //   const selectedPlansToAdd = this.selectedPlansFromPopup.filter(
        //     (selected) => !existingPlans.some((p) => p.id === selected.id),
        //   );

        //   activeMenu.plans = [...selectedPlansToAdd, ...existingPlans];
        // }

        this.listPlanByMenuKarte = fetchedPlans;
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private showModalCreateFeedback(feedback = null) {
    if (!feedback) {
      this.feedbackForm = {
        id: null,
        created_at_jp: null,
        content: '',
        plans: [],
        type: null,
        listPlans: [],
      };
    } else {
      const planIdsCsv = (feedback as any).plans.map((p: any) => p.id).join(',');
      this.getListPlansByMenu(planIdsCsv);

      this.feedbackForm = JSON.parse(JSON.stringify(feedback));
      this.feedbackForm.listPlans = [...this.feedbackForm.plans];
      this.feedbackForm.plans = this.feedbackForm.plans.map((item) => item.id);
      this.feedbackForm.old_type = this.feedbackForm.type;

      const popupPlanIds = this.selectedPlansFromPopup.map((p) => p.id);
      this.feedbackForm.plans = Array.from(new Set([
        ...this.feedbackForm.plans,
        ...popupPlanIds,
      ]));
    }

    this.prescriptionPopupRef.show(this.feedbackForm);
  }

  private savedFeedback() {
    this.getListFeedback();
  }

  private updateUserTreatmentState(data) {
    this.activeTreatment.state = data.state;
    this.$store.commit('user_treatment_list/setUserTreatmentState', this.activeTreatment);
  }

  private async saveConfirmOrder() {
    const isValid = await this.confirmOrderFormRef.validate();
    if (!isValid) {
      return;
    }

    this.isConfirming = true;
    const self = this;
    const params = {
      memo: this.orderConfirm.memo,
      order_id: this.orderConfirm.id,
    };
    await ApiHelper.getApi('PatientV2Api').doctorConfirmOrder(this.patient.id, params)
      .then((res) => {
        self.getListFeedback();
        if (res.data.userTreatment) {
          self.updateUserTreatmentState(res.data.userTreatment);
        }
        // Final prescription confirmation changes the treatment history, so
        // invalidate the cached episodes for the 治療履歴 tab.
        self.$store.commit('patient_detail/RESET_TREATMENT_EPISODES');
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(function() {
        self.isConfirming = false;
        self.$modal.hide('confirmOrderForm');
      });
  }

  private handleWhenCreateFeedback(doctorFeedback: any) {
    this.activeTreatment.state = doctorFeedback.user_treatment.state;
    this.activeTreatment.feedback_type = doctorFeedback.user_treatment.feedback_type;
    this.$store.commit('user_treatment_list/setUserTreatmentState', doctorFeedback.user_treatment);
    this.$store.commit('user_treatment_list/setUserTreatmentLatestAnswer', doctorFeedback.user_treatment);
    // Prescribing (including cancel/reserve variants) changes the treatment
    // history, so invalidate the cached episodes for the 治療履歴 tab.
    this.$store.commit('patient_detail/RESET_TREATMENT_EPISODES');
  }
  private handleUpdateListPlanWithMenu(plans: any[]) {
    const selectedPlans = plans.filter((plan) => plan.selected_from_lp === true);
    this.selectedPlansFromPopup = selectedPlans;
  }
}
